module.exports = __webpack_public_path__ + "img/550.e0acdafe.jpg";